// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const Svg3Dshare24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_5951_332015)">
					<path d="M21.0342 6.60843L13.6284 2.90557C12.737 2.45986 11.6742 2.45986 10.7827 2.90557L3.37702 6.60843C2.29702 7.14843 1.61987 8.24557 1.61987 9.45415V13.3541H3.0513V9.45415C3.0513 9.29129 3.07702 9.11986 3.11987 8.96557L3.16273 8.81986L11.4856 12.7027V17.897C11.4856 19.037 12.077 20.0656 13.0627 20.6484C13.5599 20.9399 14.117 21.0856 14.6656 21.0856C15.2142 21.0856 15.737 20.9484 16.2256 20.6741L21.1627 17.897C22.1656 17.3313 22.7827 16.2684 22.7827 15.1199V9.45415C22.7827 8.237 22.1056 7.14843 21.0256 6.60843H21.0342ZM19.8599 7.61986L12.197 11.4513L4.27702 7.757L11.4256 4.18272C11.9142 3.93415 12.5056 3.93415 12.9942 4.18272L19.8684 7.61986H19.8599ZM21.3599 9.45415V15.1199C21.3599 15.7541 21.017 16.337 20.4684 16.6456L15.5313 19.4227C14.9913 19.7313 14.3227 19.7227 13.7913 19.4056C13.2513 19.0884 12.9256 18.5227 12.9256 17.8884V12.677L21.1284 8.57986L21.1884 8.69986C21.3084 8.957 21.3684 9.20558 21.3684 9.44558L21.3599 9.45415Z" />
					<path d="M4.64564 13.8256L6.83136 14.7599L6.46279 14.8542C5.74279 15.0342 4.67136 15.4114 3.67707 16.1571C2.63136 16.9456 1.36279 18.3856 1.28564 20.7771V20.8628H2.71707V20.7771C2.77707 19.3285 3.38564 18.1628 4.53422 17.2971C5.51136 16.5685 6.59993 16.2685 7.16565 16.1571L7.40564 16.1056L6.45422 18.3256L7.76565 18.8914L9.65136 14.4942L9.68565 14.4171L5.21136 12.4971L4.64564 13.8085V13.8256Z" />
				</g>
				<defs>
					<clipPath id="clip0_5951_332015">
						<rect width={21.5057} height={18.5143} transform="translate(1.28564 2.57129)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
Svg3Dshare24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default Svg3Dshare24;
